"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnblockingUserDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
class UnblockingUserDto {
  constructor(data) {
    Object.assign(this, data);
  }
}
exports.UnblockingUserDto = UnblockingUserDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "userPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "gender", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.SubGender,
  required: false,
  nullable: true
}), __metadata("design:type", Object)], UnblockingUserDto.prototype, "subGender", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "preferredGender", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], UnblockingUserDto.prototype, "preferredGenders", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Whether preferred genders should be shown on the viewer UI.'
}), __metadata("design:type", Boolean)], UnblockingUserDto.prototype, "showGenderPreferences", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], UnblockingUserDto.prototype, "age", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "venuePublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], UnblockingUserDto.prototype, "checkedInAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], UnblockingUserDto.prototype, "isLikingMe", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], UnblockingUserDto.prototype, "isLikedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], UnblockingUserDto.prototype, "isBlockingMe", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], UnblockingUserDto.prototype, "isBlockedByMe", void 0);
//# sourceMappingURL=UnblockingUser.dto.js.map